// extracted by mini-css-extract-plugin
export default {"column":"UserAccess_column__uEY+b"};